import { render, staticRenderFns } from "./detail_news.vue?vue&type=template&id=75941fde&scoped=true"
import script from "./detail_news.vue?vue&type=script&lang=js"
export * from "./detail_news.vue?vue&type=script&lang=js"
import style0 from "./detail_news.vue?vue&type=style&index=0&id=75941fde&prod&lang=css&scoped=true"
import style1 from "./detail_news.vue?vue&type=style&index=1&id=75941fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75941fde",
  null
  
)

export default component.exports